import { render } from "./RecipesList.vue?vue&type=template&id=25ae51fa"
import script from "./RecipesList.vue?vue&type=script&lang=js"
export * from "./RecipesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__